import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { useSelector } from "react-redux"
import { noFilteredReports } from "reduxSlices/reportIndexSlice"
import { SmallWrap } from "shared/wraps"
import FormLevelReportsSection from "../FormLevelReportsSection"
import SolutionLevelReportsSection from "../SolutionLevelReportsSection"
import SurveyReportsSection from "../SurveyReportsSection"
import TaskReportsSection from "../TaskReportsSection"
import ReportsEmptyState from "./ReportsEmptyState"
import ReportsHeader from "./ReportsHeader"

const ReportsContent = ({ hiddenSidebar, toggleSidebar }) => {
  const noMatchingReports = useSelector(noFilteredReports)

  return (
    <div className={clsx("max-w-screen-xl mx-auto", !hiddenSidebar && "pl-96")}>
      <ReportsHeader
        hiddenSidebar={hiddenSidebar}
        toggleSidebar={toggleSidebar}
      />
      <SmallWrap>
        <FormLevelReportsSection className="mb-20" />
        <SolutionLevelReportsSection className="mb-20" />
        <SurveyReportsSection className="mb-20" />
        <TaskReportsSection />
        { noMatchingReports && <ReportsEmptyState /> }
      </SmallWrap>
    </div>
  )
}

ReportsContent.propTypes = {
  hiddenSidebar: types.bool.isRequired,
  toggleSidebar: types.func.isRequired,
}

export default ReportsContent
